/**
 * success: used for success status of api call
 * pending: used for responding status of api call
 * error: used for when there's error
 */
export const LoadingStatus = {
  SUCCESS: 'success',
  PENDING: 'pending',
  ERROR: 'error',
};

Object.freeze(LoadingStatus);
